up.compiler(".up_sizeable_figure", function (element) {
  const image = element.querySelector("img");
  const figcaption = element.querySelector("figcaption");
  image.onload = function () {
    const width = image.naturalWidth;
    const height = image.naturalHeight;
    image.setAttribute("width", width);
    figcaption.style.width = `100%`;
    image.setAttribute("height", height);
  };
});
